import React from 'react'

const Summary = ({ n, title, description, expand, steps }) => {
  const optional = steps.filter(s => s.optional);
  const required = steps.length - optional.length;

  return <div className="summary" onClick={expand}>
    <h3>#{n} {title}</h3>
    {description && <p>{description}</p>}
    <p>{steps.length} steps, {required} required.</p>
  </div>
};

const Expanded = ({ n, title, description, steps, done, toggle, close }) => {

  return <div className="checklist">
    <div className="checklist-header" onClick={close}>
      <h3>#{n} {title}</h3>
      {description && <p>{description}</p>}
    </div>

    <div className="checklist-body">
      {steps.map((s, idx) => {
        const isDone = done.indexOf(idx) !== -1;
        let className = isDone ? "item done" : "item";
        if (s.optional)
          className += " optional";

        return <div onClick={toggle(idx)} className={className}>
          {s.optional && <h4>Optional</h4>}
          {s.description && <p>{s.description} {s.url && <a href={s.url} target="_blank">Read more</a>}</p>}
          {s.terminal && <pre>{s.terminal}</pre>}
          {s.code && <pre className="code">{s.code}</pre>}
        </div>
      })}
    </div>
  </div>
};



export default class Checklist extends React.Component {
  state = {
    collapsed: true,
    done: []
  };

  toggle = idx => () => {
    if (this.state.done.indexOf(idx) !== -1) {
      this.setState({ done: this.state.done.filter(el => el !== idx) })
    } else {
      this.setState({ done: [...this.state.done, idx] })
    }
  };

  render() {
    if (this.state.collapsed) {
      return <Summary {...this.props.data} n={this.props.n} expand={() => this.setState({ collapsed: false })} />
    } else {
      return <Expanded {...this.props.data} n={this.props.n} toggle={this.toggle} done={this.state.done} close={() => this.setState({ collapsed: true })} />
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/checklist.js